import { render, staticRenderFns } from "./NoNotificationModal.vue?vue&type=template&id=526e14cb"
import script from "./NoNotificationModal.vue?vue&type=script&lang=js"
export * from "./NoNotificationModal.vue?vue&type=script&lang=js"
import style0 from "./NoNotificationModal.vue?vue&type=style&index=0&id=526e14cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports